// СТРАЙ РАБОЧИЙ ВАРИАНТ

// import { useEffect, useRef } from "react";
// import { socket } from "../utils/socket.js";
// import { useSelector, useDispatch } from "react-redux";
// import { setOnlineUsers, addMessage } from "../redux/chat/slice.js";
// import {
//   fetchUnreadByUser,
//   fetchUnreadCount,
// } from "../redux/chat/operations.js";
// import { jwtDecode } from "jwt-decode";

// export const useSocket = () => {
//   const dispatch = useDispatch();

//   const studentToken = useSelector((s) => s.authStudent?.studentToken);
//   const teacherToken = useSelector((s) => s.authTeacher?.teacherToken);
//   const token = studentToken || teacherToken;

//   const activeChatUserId = useSelector((s) => s.chat.activeChatUserId);
//   const activeChatRef = useRef(activeChatUserId);

//   // обновляем ref при смене чата
//   useEffect(() => {
//     activeChatRef.current = activeChatUserId;
//   }, [activeChatUserId]);

//   useEffect(() => {
//     if (token) {
//       const decoded = jwtDecode(token);
//       socket.emit("register", { userId: decoded.id });
//     }

//     socket.on("online-users", (users) => {
//       dispatch(setOnlineUsers(users));
//     });
//     socket.onAny((event, ...args) => {
//       console.log("SOCKET EVENT:", event, args);
//     });
//     socket.on("receive-message", (message) => {
//       dispatch(addMessage(message));

//       // если юзер не в чате — обновляем счётчики
//       if (activeChatRef.current !== message.sender_id) {
//         dispatch(fetchUnreadCount());
//         dispatch(fetchUnreadByUser());
//       }
//     });

//     return () => {
//       socket.off("online-users");
//       socket.off("receive-message");
//     };
//   }, [token, dispatch]);
// };

// ВАРИАНТ С RECONECT

import { useEffect, useRef } from "react";
import { socket } from "../utils/socket.js";
import { useSelector, useDispatch } from "react-redux";
import { setOnlineUsers, addMessage } from "../redux/chat/slice.js";
import {
  fetchUnreadByUser,
  fetchUnreadCount,
} from "../redux/chat/operations.js";
import { jwtDecode } from "jwt-decode";

export const useSocket = () => {
  const dispatch = useDispatch();

  const studentToken = useSelector((s) => s.authStudent?.studentToken);
  const teacherToken = useSelector((s) => s.authTeacher?.teacherToken);
  const token = studentToken || teacherToken;

  const activeChatUserId = useSelector((s) => s.chat.activeChatUserId);
  const activeChatRef = useRef(activeChatUserId);

  // 🔁 Сохраняем актуальный активный чат
  useEffect(() => {
    activeChatRef.current = activeChatUserId;
  }, [activeChatUserId]);

  useEffect(() => {
    if (!token) return;

    const decoded = jwtDecode(token);
    const userId = decoded.id;

    // 🔌 Первая регистрация
    socket.emit("register", { userId });

    // ✅ Повторная регистрация после reconnect
    // eslint-disable-next-line no-unused-vars
    socket.on("reconnect", (attempt) => {
      // console.log(`🔄 Socket reconnected after ${attempt} tries`);
      socket.emit("register", { userId });
    });

    // 🟢 Успешное подключение
    socket.on("connect", () => {
      // console.log("✅ Socket connected:", socket.id);
    });

    // 🔴 Ошибка подключения
    // eslint-disable-next-line no-unused-vars
    socket.on("connect_error", (err) => {
      // console.error("❌ Socket connect error:", err.message);
    });

    // 👥 Онлайн пользователи
    socket.on("online-users", (users) => {
      dispatch(setOnlineUsers(users));
    });

    // 📩 Получение сообщения
    // socket.on("receive-message", (message) => {
    //   dispatch(addMessage(message));

    //   // если юзер не в активном чате — обновляем счётчики
    //   if (activeChatRef.current !== message.sender_id) {
    //     dispatch(fetchUnreadCount());
    //     dispatch(fetchUnreadByUser());
    //   }
    // });

    // рабочий вариант с проверкой на повторное добавление
    socket.on("receive-message", (message) => {
      // не добавляем повторно, если сообщение от текущего пользователя
      const decoded = jwtDecode(token);
      const currentUserId = decoded?.id;
      const currentUserRole = decoded?.role;

      const isOwnMessage =
        message.sender_id === currentUserId &&
        message.sender_role === currentUserRole;

      if (!isOwnMessage) {
        dispatch(addMessage(message));
      }

      // всегда обновляем счётчики, если не активный чат
      if (activeChatRef.current !== message.sender_id) {
        dispatch(fetchUnreadCount());
        dispatch(fetchUnreadByUser());
      }
    });
    // 🛠 Лог всех событий
    // eslint-disable-next-line no-unused-vars
    socket.onAny((event, ...args) => {
      // console.log("SOCKET EVENT:", event, args);
    });

    return () => {
      socket.off("connect");
      socket.off("reconnect");
      socket.off("connect_error");
      socket.off("online-users");
      socket.off("receive-message");
      socket.offAny();
    };
  }, [token, dispatch]);
};
